export default __webpack_public_path__ + "static/media/cardimage5.2fac6525.png";